/** Лимит ассетов для поля поиска в виде инпута с саджестами */
export const SEARCHING_LIMIT_FOR_FIELD = 3;
/** Лимит ассетов для поля поиска в виде модалки с саджестами */
export const SEARCHING_LIMIT_FOR_MODAL = 5;

export const MIN_SEARCH_SIZE = 2;
export const MAX_SEARCH_SIZE = 32;

export const SEARCHING_FETCH_DEBOUNCE_TIME = 500;
